var Stats = require('/src/lib/util/math/stats');

module.exports = function(individualCards) {
	var cmcs = [];
	var curve = [];
	var colors = {"R": [], "G": [], "B": [], "W": [], "U": []};
	
	individualCards.forEach(function(c) {
		if (c.cmc && c.manaCost) {
			cmcs.push(c.cmc);
			var cmcKey = Math.min(8, c.cmc);
			var bucketCount = curve[cmcKey] || 0;
			curve[cmcKey] = bucketCount + 1;

			var cardCosts = c.manaCost.match(/\{([\/A-Z0-9]+)\}/g);
			cardCosts.forEach(function(costCode) {
				colorOptions = costCode.replace(/\{|\}/g, '').split(/\//);
				colorOptions.forEach(function(color) {
					if (colors[color]) {
						var bucketCount = colors[color][cmcKey] || 0;
						colors[color][cmcKey] = bucketCount + 1/colorOptions.length;
					}
				});
			});
		}
	});

	this.cmcs = cmcs;
	this.curve = curve;
	this.colors = colors;
	this.median = Stats.median(cmcs);
	this.total = Stats.sum(cmcs);
	
};
